export default class GoolgePlace {
  address1 = '';
  zip = '';
  city?: string;
  state?: string;
  country?: string;
}
